module.exports = __webpack_public_path__ + "static/img/1_1_3.4ad64b47.jpg";